import {Link} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import affiliate_1 from "../feature/affiliate_1.jpg";
import affiliate_2 from "../feature/affiliate_2.jpg";
import affiliate_3 from "../feature/affiliate_3.jpg";
import main from "../feature/pymt.webp";
import { Phone,} from 'react-feather';
import AffiliateEarningsCalculator from './AffiliateEarningsCalculator';
import FeaturesBottom from './FeaturesBottom';

function LinkInBioFeaturePage(){

      

    return (
        <>
            <Helmet>
                <title>Kadhr Affiliate Program</title>
                <meta name="description" content={`Kadhr Affiliate Program`} />
            </Helmet>
            <main className="mtopcon0 ovrflwhdn" id="up">
                <a href="https://wa.me/254794072134" target='_blank' className="wappcomms btn-hover float-left">
                    <Phone className='text-white'/>
                </a>
                <div className="row">
                    <div className="col-12 text-center text-white pt-6indx bg-blue0">
                        <h1 className='mb-3 display-4 font-bold'><b>Earn 20% commission <br/> per month</b></h1>
                        <p className='mb-4 font1'>Turn your network into income. <br/>Earn 20% monthly commissions for every business you bring to Kadhr.</p>
                        
                        <p>
                            <Link className="main-btn btn-hover text-white bg-dark" to="/seller/register">Start Earning Now</Link>
                        </p>

                        <div className='col-12'>                        
                            <div className="welcome-banner mt-5 br10">
                                <picture>
                                    <source media="(min-width: 768px)" srcSet={main} />
                                    <img loading="lazy" src={main} alt="Responsive image" className="w-100 h-100" />
                                </picture>

                            </div>
                        </div>
                    </div>  
                    
                    <div className="col-12 text-center mt-5 pt-6indx0" id='features'>
                        <div className="col-12">
                            <div className='container'>
                                <h2 className="mb-5 text-center hmpg-header"><b>How it works</b></h2>
                                <div className="row">
                                    {/* Smart Business Management */}
                                    <div className="col-lg-4 col-12 col-md-auto bg-white" id="business-management">
                                        <div className='card p-4 br40'>
                                            <span className="yrprc savegreen col-4">STEP 1</span>
                                            <div className="col-12 mt-3 text-left">
                                                <h4 className="mb-2"><b>Share Your Link</b></h4>
                                                <p className='font9'>After <Link to='/seller/register'>joining the family</Link>, copy your unique referral link then post it, share it, or DM it. Track every click and signup.</p>
                                            </div>
                                            <div className="feature-imgcon"><img loading="lazy" src={affiliate_1} /></div>
                                        </div>
                                    </div>

                                    {/* Customer Engagement & Growth */}
                                    <div className="col-lg-4 col-12 col-md-auto" id="customer-engagement">
                                        <div className='card p-4 br40'>
                                            <span className="yrprc savegreen col-4">STEP 2</span>
                                            <div className="col-12 mt-3 text-left">
                                                <h4 className="mb-2"><b>Earn Recurring Income</b></h4>
                                                <p className='font9'>Get 20% monthly commissions for every seller who subscribes through your link and enjoy <b className='grey-text'>Instant Withdrawals</b>.</p>
                                            </div>
                                            <div className="feature-imgcon"><img loading="lazy" src={affiliate_2} /></div>
                                        </div>
                                    </div>

                                    {/* Data-Driven Insights & Optimization */}
                                    <div className="col-lg-4 col-12 col-md-auto" id="analytics">
                                        <div className='card p-4 br40'>
                                            <span className="yrprc savegreen col-4">STEP 3</span>
                                            <div className="col-12 mt-3 text-left">
                                                <h4 className="mb-2"><b> Bonus Milestones</b></h4>
                                                <p className='font9'>Unlock cash bonuses when your referrals hit 10K in sales, complete their first M-Pesa sale, and more.</p>
                                            </div>
                                            <div className="feature-imgcon"><img loading="lazy" src={affiliate_3} /></div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="col-12 pt-6indx0 text-center" id='features'>
                        <div className="col-12">
                            <div className='container'>                                
                                <div className="row">
                                    <div className='col-12'><AffiliateEarningsCalculator /></div>
                                </div>
                            </div>
                        </div>
                    </div>   
                    
                    <div className="background0 mt-6 pt-6indx0">
                        <div className="content0">                        
                            <h2 className='mt-4'>Leaderboards & Monthly Payouts</h2>
                            <p className='font9 mt-4'>Rise through the ranks and watch your impact grow. Our leaderboard celebrates top affiliates every month with special rewards.</p>
                            <div  className="row mb-4 mt-4">
                                <div  className="col-12 col-md-12 text-center">                                            
                                    <Link className="main-btn btn-hover text-white bg-blue" to="/seller/register">Start Earning Now</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mt-6 pt-6indx0">
                        <div className='container'>
                            <h2 className="text-center mb-5 hmpg-header"><b>FAQs</b></h2>
                            <div className="accordion" id="accordionAffiliateFAQ">

                                {/* 1. How much commission do I earn? */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#affq1" aria-expanded="true" aria-controls="affq1">                                            
                                            How much commission do I earn?
                                        </button>
                                    </h2>
                                    <div id="affq1" className="accordion-collapse collapse show" data-bs-parent="#accordionAffiliateFAQ">
                                        
                                        <div className="accordion-body font9">
                                            You earn <strong>20% recurring commission</strong> for every vendor you refer. That means every time they renew their subscription, you get paid again. Turn one referral into long-term passive income.
                                        </div>
                                    </div>
                                </div>

                                {/* 2. How does the Kadhr Affiliate Program work? */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#affq2" aria-expanded="false" aria-controls="affq2">
                                            How does the Kadhr Affiliate Program work?
                                        </button>
                                    </h2>
                                    <div id="affq2" className="accordion-collapse collapse" data-bs-parent="#accordionAffiliateFAQ">
                                        <div className="accordion-body font9">
                                            You share your unique affiliate link with vendors. When they sign up and pay for any Kadhr plan, you earn a commission. Simple as that. No extra tools needed—Kadhr tracks everything for you automatically.
                                        </div>
                                    </div>
                                </div>

                                {/* 3. Do I earn if the vendor keeps paying monthly? */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#affq3" aria-expanded="false" aria-controls="affq3">
                                            Do I earn if the vendor keeps paying monthly?
                                        </button>
                                    </h2>
                                    <div id="affq3" className="accordion-collapse collapse" data-bs-parent="#accordionAffiliateFAQ">
                                        <div className="accordion-body font9">
                                            Yes! Your commission is recurring. If your referral stays subscribed for 6 months, you get paid every single month they remain active.
                                        </div>
                                    </div>
                                </div>

                                {/* 4. How and when do I get paid? */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#affq4" aria-expanded="false" aria-controls="affq4">
                                            How and when do I get paid?
                                        </button>
                                    </h2>
                                    <div id="affq4" className="accordion-collapse collapse" data-bs-parent="#accordionAffiliateFAQ">
                                        <div className="accordion-body font9">
                                            You can request an instant withdrawal anytime your earnings cross the minimum payout threshold. Payouts are processed via M-Pesa or bank transfer through our secure Paystack system.
                                        </div>
                                    </div>
                                </div>

                                {/* 5. Is there a minimum payout amount? */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#affq5" aria-expanded="false" aria-controls="affq5">
                                            Is there a minimum payout amount?
                                        </button>
                                    </h2>
                                    <div id="affq5" className="accordion-collapse collapse" data-bs-parent="#accordionAffiliateFAQ">
                                        <div className="accordion-body font9">
                                            Yes. The minimum payout is <strong>KES 500</strong> (or $5 for international affiliates). This ensures smooth processing of your payments without delays.
                                        </div>
                                    </div>
                                </div>

                                {/* 6. Can I track my referrals and earnings? */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#affq6" aria-expanded="false" aria-controls="affq6">
                                            Can I track my referrals and earnings?
                                        </button>
                                    </h2>
                                    <div id="affq6" className="accordion-collapse collapse" data-bs-parent="#accordionAffiliateFAQ">
                                        <div className="accordion-body font9">
                                            Absolutely. Your affiliate dashboard shows total referrals, paying referrals, and total commissions earned. Everything is transparent and updated in real-time.
                                        </div>
                                    </div>
                                </div>

                                {/* 7. What are the benefits of joining Kadhr's affiliate program? */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#affq7" aria-expanded="false" aria-controls="affq7">
                                            What are the benefits of joining Kadhr's affiliate program?
                                        </button>
                                    </h2>
                                    <div id="affq7" className="accordion-collapse collapse" data-bs-parent="#accordionAffiliateFAQ">
                                        <div className="accordion-body font9">
                                            - <strong>High commissions:</strong> Earn 20% recurring revenue.<br />
                                            - <strong>Instant payouts:</strong> Withdraw anytime.<br />
                                            - <strong>Lifetime value:</strong> Get paid as long as your referrals stay active.<br />
                                            - <strong>Exclusive bonuses:</strong> Hit milestones and earn extra rewards.<br />
                                            - <strong>No limits:</strong> Refer as many vendors as you can.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 mt-5">
                                <div className="col-12 col-md-12 text-center">
                                    <a className="main-btn btn-hover text-white bg-dark" href="/seller/register">
                                        Join the Affiliate Program
                                    </a>
                                    <p className="mt-3 text-muted small">Start earning today. It’s free to join, no hidden costs.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <FeaturesBottom/>
                </div>
            </main>
        </>
    )
}

export default LinkInBioFeaturePage;
